module.exports = __webpack_public_path__ + "img/arrow__faq.d742daef.svg";